document.addEventListener('DOMContentLoaded', function documentLoad() {
	function loadMorePosts() {
		document.getElementById('award-loadmore-button').style.display = 'none';
		document.getElementById('award-loadmore-loader').style.display = 'block';
		const page = document.getElementById('award-pagination-page').value;
		const offset = document.getElementById('award-pagination-offset').value;
		const maxPages = document.getElementById('award-max-page').value;
		const postType = document.getElementById('award-post-type').value;
		const elems = document.querySelectorAll('.display_year');
		const len = elems.length;
		const awardYear = len < 1 ? '' : elems[len - 1].getAttribute('data-attr');
		let orderBy = '';
		if (document.getElementById('order_by')) {
			orderBy = document.getElementById('order_by').value;
		}
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response) {
					document.getElementById('award-loadmore-button').style.display = 'block';
					document.getElementById('award-loadmore-loader').style.display = 'none';
					document
						.querySelector('.award-loadmore-container')
						.insertAdjacentHTML('beforeend', response.html);
					document.getElementById('award-pagination-page').value = response.page;
					document.getElementById('award-pagination-offset').value = response.offset;
					if (parseInt(page, 0) + 1 > parseInt(maxPages, 0)) {
						document.getElementById('award-loadmore-button').style.display = 'none';
					}
				}
			}
		};
		const ajaxNonce = ajaxload_params.nonce; //eslint-disable-line
		xhr.send(
			`action=award_load_more_posts&page=${page}&offset=${offset}&post_type=${postType}&order_by=${orderBy}&award_year=${awardYear}&posts_per_page=10&nonce=${ajaxNonce}`,
		);
	}

	const loadMoreButton = document.getElementById('award-loadmore-button');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function (e) {
			e.preventDefault();
			loadMorePosts();
		});
	}

	const tagsWrappers = document.querySelectorAll('.award-wrapper');
	tagsWrappers.forEach(function (tagsWrapper) {
		if (tagsWrapper.children[0].children.length === 0) {
			tagsWrapper.children[0].remove();
		}
	});
});
